import { useEffect, useRef } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import DynamicTable from "src/components/table";
import { columntype, isValidArray } from "src/helper/publicFunction";
import { CommonAlert } from "src/components/alert/CommonAlert";
import {
  GetCbtApplications,
  ActivateCbtApplication,
  DeactivateCbtApplication,
  DeleteCbtApplication,
} from "./actions";

const Cbt = () => {
  const dispatch = useDispatch();
  const Commonalert = CommonAlert();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [loadingEditdatatype, setloadingEditdatatype] = useState("");
  const [data, setData] = useState([]);
  const [TotalData, setTotalData] = useState(0);

  const GetData = () => {
    setLoadingData(true);
    setData([]);
    dispatch(
      GetCbtApplications({
        page: page + 1,
        rowsPerPage,
        search,
        callback: (response) => {
          if (isValidArray(response?.data)) {
            setData(
              response.data.map((item) => ({
                ...item,
                is_active_display: item?.is_active === 1 ? "true" : "false",
              }))
            );
            setTotalData(response?.count ?? response.data.length);
          } else {
            setData([]);
            setTotalData(0);
          }
          setLoadingData(false);
        },
      })
    );
  };

  useEffect(() => {
    GetData();
  }, [page, rowsPerPage, search]);

  const columns = [
    { type: columntype.text, name: "id" },
    { type: columntype.dateAndtime, name: "createdAt" },
    { type: columntype.vid, name: "ba_diploma" },
    { type: columntype.vid, name: "ba_transcript" },
    { type: columntype.vid, name: "msc_diploma" },
    { type: columntype.vid, name: "msc_transcript" },
    { type: columntype.vid, name: "cv" },
    { type: columntype.vid, name: "cover_letter" },
    { type: columntype.vid, name: "id_or_passport" },
    { type: columntype.text, name: "is_active_display" },
  ];

  const headCells = [
    { id: "id", numeric: false, disablePadding: false, label: "ID", withSort: false },
    { id: "createdAt", numeric: false, disablePadding: false, label: "Created", withSort: false },
    { id: "ba_diploma", numeric: false, disablePadding: false, label: "BA Diploma", withSort: false },
    { id: "ba_transcript", numeric: false, disablePadding: false, label: "BA Transcript", withSort: false },
    { id: "msc_diploma", numeric: false, disablePadding: false, label: "MSC Diploma", withSort: false },
    { id: "msc_transcript", numeric: false, disablePadding: false, label: "MSC Transcript", withSort: false },
    { id: "cv", numeric: false, disablePadding: false, label: "CV", withSort: false },
    { id: "cover_letter", numeric: false, disablePadding: false, label: "Cover Letter", withSort: false },
    { id: "id_or_passport", numeric: false, disablePadding: false, label: "ID/Passport", withSort: false },
    { id: "is_active_display", numeric: false, disablePadding: false, label: "Active", withSort: false },
    { id: "action", numeric: false, disablePadding: false, label: "Action", withSort: false },
  ];

  const List = [
    {
      name: "Activate",
      function: async (row) => {
        if (row && row.is_active === 0) {
          dispatch(
            ActivateCbtApplication({
              id: row.id,
              callback: (res) => {
                if (res) GetData();
              },
            })
          );
        }
      },
      show: (row) => row?.is_active === 0,
    },
    {
      name: "Deactivate",
      function: async (row) => {
        if (row && row.is_active === 1) {
          dispatch(
            DeactivateCbtApplication({
              id: row.id,
              callback: (res) => {
                if (res) GetData();
              },
            })
          );
        }
      },
      show: (row) => row?.is_active === 1,
    },
    {
      name: "Delete",
      function: async (row) => {
        if (row) {
          Commonalert.show({
            title: `Are you sure to delete application #${row?.id}?`,
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteCbtApplication({
                      id: row.id,
                      callback: () => GetData(),
                    })
                  ),
                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }
      },
    },
  ];

  const updateDataApi = ({ row, failedName, newData }) => {
    setloadingEditdatatype(`${row?.id}-${failedName}`);
    const isActivating = newData === 1 || newData === true;
    dispatch(
      isActivating
        ? ActivateCbtApplication({
            id: row.id,
            callback: (res) => {
              if (res) GetData();
              setloadingEditdatatype("");
            },
          })
        : DeactivateCbtApplication({
            id: row.id,
            callback: (res) => {
              if (res) GetData();
              setloadingEditdatatype("");
            },
          })
    );
  };

  const debounceRef = useRef(null);

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearch(value);

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      if (value === "" || !value) {
        return;
      }

      dispatch(
        GetCbtApplications({
          rowsPerPage,
          page: page + 1,
          search: value,
          callback: (response) => {
            if (isValidArray(response?.data)) {
              setData(
                response.data.map((item) => ({
                  ...item,
                  is_active_display: item?.is_active === 1 ? "true" : "false",
                }))
              );
              setTotalData(response?.count ?? response.data.length);
            }
          },
        })
      );
    }, 1000);
  };

  return (
    <>
      <DynamicTable
        handleSearch={handleSearch}
        onRequestSort={() => {}}
        onPressDelete={(ids) => {
          Commonalert.show({
            title: "Are you sure?",
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () => {
                  Promise.all(
                    (Array.isArray(ids) ? ids : [ids]).map((id) =>
                      dispatch(
                        DeleteCbtApplication({
                          id,
                          callback: () => {},
                        })
                      )
                    )
                  ).then(() => GetData());
                },
                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }}
        onPressItem={() => {}}
        onPressAnyAction={(row, failedName, newData) => {
          updateDataApi({ row, failedName, newData });
        }}
        onPressAdd={() => {}}
        items={data}
        columns={columns}
        headCells={headCells}
        page={page}
        setPage={setPage}
        selected={selected}
        setSelected={setSelected}
        search={search}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        Listdropdown={List}
        withOption={true}
        loadingData={loadingData}
        rowsPerPageOptions={[5, 10, 25, 50]}
        totalItem={TotalData}
        loadingEditdatatype={loadingEditdatatype}
        withAddButton={false}
        withDeleteItem={false}
        withEditItem={true}
        withPagination={true}
        withSearch={true}
      />
    </>
  );
};

export default Cbt;
